import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import BurgerBarMenu from "assets/icons/BurgerBarMenu.png";

function Navbar({ openMenu }) {
  const { t } = useTranslation();
  const dropdownRef = useRef(null);
  const navbarRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(null);

  const navigation = [
    {
      id: 1,
      label: t("aboutUs"),
      href: "/about",
    },
    {
      id: 2,
      label: t("charity"),
      href: "/charity",
    },
    {
      id: 3,
      label: t("ourSponsors"),
      href: "/sponsors",
    },
    {
      id: 4,
      label: t("ticketPrice"),
      href: "/prices",
    },
    // {
    //   id: 4,
    //   label: t('faq'),
    //   href: "/faq",
    // },
    {
      id: 5,
      label: t("contactUs"),
      href: "/contact-us",
    },
  ];

  const handleMouseOver = useCallback(
    (e) => {
      if (
        dropdownOpen &&
        !dropdownRef?.current?.contains(e.target) &&
        !navbarRef?.current?.contains(e.target)
      ) {
        setDropdownOpen(null);
      }
    },
    [dropdownOpen, setDropdownOpen]
  );

  useEffect(() => {
    window.addEventListener("mouseover", handleMouseOver);
    return () => {
      window.removeEventListener("mouseover", handleMouseOver);
    };
  }, [handleMouseOver]);

  return (
    <>
      <div className={`sticky top-0 shadow-md transition-all z-10 bg-white`}>
        <div
          ref={navbarRef}
          className={`app-nav-container flex justify-between items-center gap-6`}
        >
          <div>
            <a href="/">
              <img
                src={
                  "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/012f79f18bd4ee5ca24a024d02924ba84f004046e8a139fd33e82d02164b994a514bb11d7c5ece7ed43c62dbd3638a2aabbcefb82935d1a511710f3308cc8ca97f0c9058a339dbd73aa6f98b3fbb2fc972914157ba54e7720645664dd6d7822caabdfb2b35dcfde734715b8dca4bd96059465fdaa95661d4c035/rez-file-1750150206233.png"
                }
                alt="logo"
                className="w-32 lg:w-52"
              />
            </a>
          </div>
          <div className={`hidden sm:flex md:space-x-12 text-black font-bold`}>
            <ul className="flex items-center space-x-4 sm:text-sm md:text-base">
              {navigation.map((nav) => (
                <li key={nav?.id} onMouseOver={() => setDropdownOpen(nav?.id)}>
                  <a
                    className="hover:border-b border-black pb-1"
                    href={nav.href}
                  >
                    {nav.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <button
            className="text-black text-sm sm:hidden active:border-b-2 active:border-white transition-all font-medium"
            onClick={openMenu}
          >
            <img
              src={BurgerBarMenu}
              alt="burger-bar-menu"
              className="h-8 fill-black"
            />
          </button>
        </div>
        <div
          ref={dropdownRef}
          className={`absolute left-0 right-0 z-30 shadow-md bg-black ${
            navigation?.[dropdownOpen - 1]?.dropdownNav?.length > 0
              ? "block"
              : "hidden"
          } transition-all`}
        >
          <ul className="app-main-container py-4 lg:py-6 grid grid-cols-3 gap-4 text-black">
            {navigation?.[dropdownOpen - 1]?.dropdownNav?.map((nav) => (
              <li key={nav?.id}>
                <a
                  className="hover:border-b transition-all duration-300"
                  href={nav.href}
                >
                  {nav.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}

export default Navbar;
